import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { getNotificationsQueryKey } from '@/features/notifications/hooks/use-notifications';
import {
  createTrackingRequest,
  CreateTrackingRequestProps,
} from '@/features/projects/kpi-tracking-entry/api/create-tracking-request';

type Props = Omit<
  UseMutationOptions<
    Awaited<ReturnType<typeof createTrackingRequest>>,
    unknown,
    CreateTrackingRequestProps
  >,
  'mutationFn'
>;
export const useCreateTrackingRequest = (props?: Props) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...props,
    mutationFn: createTrackingRequest,
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: getNotificationsQueryKey(variables.orgId),
      });
      props?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
